import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import classNames from "classnames";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { instance } from "../../../../Actions/AxiosInstance";
import { RightDrawer } from "../../../../Actions/commonAction";
import { updateSubscriptionInfo } from "../../../../Actions/SubscriptionInfo";
import defaultEmp from "../../../../Assets/Images/defaultEmp.svg";
import payrollglyph from "../../../../Assets/Svg/payroll-glyph-16-px.svg";
import createstore from "../../../../store";
import { getFormattedImageLink } from "../../../../Utils";
import Chip from "@material-ui/core/Chip";
import If from "../../../../Component/Common/If"; 
import Button from "@material-ui/core/Button";
import NoRecordFoundImg from "Assets/Images/no-record.svg";

import get from "lodash/get";
import {
  profilePrivacyInfo,
  CheckActionPermission,
} from "../../../../Actions/commonAction";

import EmpBankingFormDrawer from "./EmpBankingFormDrawer";
import CreateComp from "../create";
import { NoRecordFound } from "./NoRecordFound";
import addressEmployee from "../../../../Assets/Images/banking-details.svg";
import Drawer from "@material-ui/core/Drawer";
import Typography from "@material-ui/core/Typography";
import { Card } from "@material-ui/core";
import { fontFamily } from "@mui/system";
import { NoEncryption } from "@material-ui/icons";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },
  padding40: {
    padding: 0,
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(45deg)",
  },
});

class EmpTeam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 10,
      managerlimit: 3,
      ManagerList: [],
      EmpList: [],
      DepList: [],
      list: [],
      TeamEmpList: [],
      colleagueid: "",
      // Emplist: [],
      OpenFlag: false,
      fullcount: "",
      managerfullcount: "",
      teamfullcount: "",
      employeeid: "",
      allBankingDetails: [],
      hideButton: false,
      openOptions: false,
      openDrawer: false,
    };
    this.selectedElement = React.createRef();
    this.toggleDrawer = this.toggleDrawer.bind(this);
  }

  componentDidMount() {
    // this.props.ChangeLanguage("");
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    let employeeid;

    const { AuthenticationAction } = createstore.getState();
    employeeid = AuthenticationAction.login.employeeid;
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;

    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const [isTrue, permissions] = CheckActionPermission("profile");
    let hideButton;
    permissions.editable
    ? colleagueid && colleagueid != employeeid
      ? masterprofileid != 9
        ? (hideButton = true)
        : (hideButton = false)
      : (hideButton = false)
    : masterprofileid != 9 ? (hideButton = true) : (hideButton = false);
    this.setState(
      {
        SubscriptionInfo,
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        colleagueid,
        hideButton
      },
      () => {
        // this.GetManagerList();
        // this.GetEmpList();
        // this.GetDepList();
        this.GetAllBankingDetails();
      },
    );
  }

  toggleDrawer(value) {
    this.setState({ openDrawer: value });
  }

  GetAllBankingDetails() {
    const URL = "employee/getempallbankdetail";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        if (result.data.result.length == 0) {
          this.setState({ flag: 0, dataReceived: true });
        } else {
          this.setState({
            allBankingDetails: result.data.result.filter((x) => x.isdefault == true),
            flag: 3,
            dataReceived: true,
          });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetPerticularBankingDetails(value, data) {
    const BankingDetails = data;
    const flag = value;
    this.setState({ BankingDetails, flag });
    this.toggleDrawer(true);
  }
 
  HelperSliderFlag(flag, text) {
    // this.setState({ HelperSlider: flag })
    let OpenFlag = "";
    if (flag == true) {
      OpenFlag = true;
      this.setState({ OpenFlag });
    } else {
      OpenFlag = false;
      this.setState({ OpenFlag });
    }
    if (text == "Profilemanager") {
      this.props.RightDrawer({
        drawerdata: text,
        open: "right",
        side: flag,
        empid: this.state.employeeid,
      });
    } else {
      this.props.RightDrawer({ drawerdata: text, open: "right", side: flag });
    }
  }

  GetManagerList() {
    const id = this.state.colleagueid
      ? this.state.colleagueid
      : this.state.employeeid;
    instance
      .get(
        `/subscription/getempolyeemanager/${id}/${3}/${this.state.offset}/${
          this.state.managerlimit
        }`,
      )
      .then((result) => {
        let ManagerList = [];
        result.data.result.length > 0
          ? (ManagerList = result.data.result)
          : (ManagerList = []);
        const managerfullcount =
          result.data.result.length > 0 ? result.data.result[0].totalcount : 0;
        this.setState({ ManagerList, managerfullcount });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetEmpList() {
    const URL = "/employee/getempteamemployee";
    const data = {
      limit: 7,
      offset: 0,
      isteamemployee: true,
    };
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        // data = {
        //     "employeeid": this.state.colleagueid
        // }
        // Object.assign(data, { employeeid: this.state.colleagueid });
        data.employeeid = this.state.colleagueid;
      } else {
        // data = {}
      }
    } else {
      // data = {
      //     "accountid": this.state.accountid,
      //     "subscriptionid": this.state.subscriptionid,
      //     "timezoneid": this.state.countrytimezoneid,
      //     "employeeid": this.state.employeeid,

      // }
      // Object.assign(data, {
      //   accountid: this.state.accountid,
      //   subscriptionid: this.state.subscriptionid,
      //   timezoneid: this.state.countrytimezoneid,
      //   employeeid: this.state.employeeid,
      // });
      data.accountid = this.state.accountid;
      data.subscriptionid = this.state.subscriptionid;
      data.timezoneid = this.state.countrytimezoneid;
      data.employeeid = this.state.employeeid;
    }
    instance
      .post(URL, data)
      .then((result) => {
        let EmpList = [];
        result.data.result.length > 0
          ? (EmpList = result.data.result)
          : (EmpList = []);
        const teamfullcount =
          result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
        this.setState({ EmpList, teamfullcount });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetDepList() {
    const URL = "/employee/getempteamemployee";
    const data = {
      limit: 7,
      offset: 0,
      isteamemployee: false,
    };
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        // data = {
        //     "employeeid": this.state.colleagueid
        // }
        data.employeeid = this.state.colleagueid;
      } else {
        // data = {}
      }
    } else {
      // data = {
      //     "accountid": this.state.accountid,
      //     "subscriptionid": this.state.subscriptionid,
      //     "timezoneid": this.state.countrytimezoneid,
      //     "employeeid": this.state.employeeid,

      // }
      // Object.assign(data, {
      data.accountid = this.state.accountid;
      data.subscriptionid = this.state.subscriptionid;
      data.timezoneid = this.state.countrytimezoneid;
      data.employeeid = this.state.employeeid;
      // });
    }
    console.log("data: ", data);
    instance
      .post(URL, data)
      .then((result) => {
        let EmpList = [];
        result.data.result.length > 0
          ? (EmpList = result.data.result)
          : (EmpList = []);
        const fullcount =
          result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
        this.setState({ DepList: EmpList, fullcount });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getCount = (count) => {
    if (count >= 7) {
      return count - 7;
    }
    return 0;
  };

  getCountManager = (count) => {
    if (count >= 3) {
      return count - 3;
    }
    return 0;
  };

  SetFlag(value, success) {
    const flag = value;
    const successFlag = success;
    this.setState({ flag, BankingDetails: {}, successFlag }, () => {
      if (flag != 1) this.GetAllBankingDetails();
      this.props.UpdateStrength(true);
    });
  }

  SetColleagueInfo(colleagueInfo, e) {
    // if (this.state.colleagueid){
    //     this.props.history.push(`./${colleagueInfo.employeeid}`);
    // }else {
    // this.props.history.push(`./profile/${colleagueInfo.employeeid}`);
    // }
    // let result = {
    //     'data' : {'result': []}
    // }
    // colleagueInfo.employeeid
    // let colleagueid = this.state.SubscriptionInfo.SubscriptionData['colleagueid'] = colleagueInfo.employeeid
    // let info = this.state.SubscriptionInfo.SubscriptionData
    // result.data.result[0] = Object.assign(colleagueid, info);
    // result;
    // this.props.updateSubscriptionInfo(ReducersTypes.SUBSCRIPTIONINFO + '_FULFILLED', result)
    // window.open("https://www.youraddress.com","_self")
  }

  DeleteEmpBankingDetails = (item) => {
    const URL = `employee/deleteempbankdetail/${item.employeebankid}`;
    instance
      .delete(URL)
      .then(() => {
        this.GetAllBankingDetails();
        this.props.closeSnackbar();
        this.setState({flag:0 });
      })
      .catch((error) => {
        this.props.closeSnackbar();
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  };

  Deleteconfirmation = (item) => {
    this.props.enqueueSnackbar(`Are you sure you want to delete?`, {
      variant: "warning",
      action: [
        <Button
          variant="outlined"
          color="inherit"
          className="margin-right-16"
          size="small"
          onClick={() => this.DeleteEmpBankingDetails(item)}
        >
          Delete
        </Button>,
        <Button color="inherit" size="small"
          onClick={() => this.props.closeSnackbar()}>
          Cancel
        </Button>,
      ],
    });
  };

  render() {
    let model;
    const { flag ,openOptions, openDrawer} = this.state;
    const { hideButton } = this.state;
    const { classes } = this.props;

    if (flag == 0 && this.props.ismandate == false) {
      model = (
        <div>
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {!hideButton ? (

                // <div>
                //   <FormattedMessage id="LbBanking" defaultMessage="Banking" />
               
                // <Button onClick={() => this.toggleDrawer(true)
                // }>
                //   Add Bank
                // </Button>
                // </div>

                      <Grid container>
                        <Grid container className="config-landing-content-container">
                        <Grid item xs={12} md={6} sm={12} >
                        <div className="text-align-left" style={{marginLeft:8}}>

                        <h6 style={{marginTop:2, marginBottom:2}}>Banking</h6>
                          <p className="p" style={{marginTop:-2, marginBottom:-2}}>"Boring but critical info. This is where the money goes."</p>
                            <Button
                              variant="contained"
                              color="primary"
                              className="addbutton"
                              onClick= {() => this.toggleDrawer(true)}
                            >
                              Add Bank
                            </Button>
                            </div>
                        
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                          <div className="right">
                            
                            {<img src={addressEmployee} style={{width:"42%"}}/>}
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>

                
              ) : (
                <div>
           <Grid container>
                        <Grid container className="config-landing-content-container">
                        <Grid item xs={12} md={6} sm={12} >
                        <div className="text-align-left" style={{marginLeft:8}}>

                        <h6 style={{marginTop:2, marginBottom:2}}>Banking</h6>
                          <p className="p" style={{marginTop:-2, marginBottom:-2}}>No record found</p>
                           
                            </div>
                        
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                          <div className="right">
                            
                            {<img src={NoRecordFoundImg} style={{width:"30%"}}/>}
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                {/* <NoRecordFound /> */}
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      );
    }

    // if (flag === 1) {
      
        


    //     // <div>
    //     //   <EmpBankingForm
    //     //     SetFlag={this.SetFlag.bind(this)}
    //     //     data={this.state.BankingDetails}
    //     //     {...this.props}
    //     //   />
    //     // </div>
      
    // }

    // if (flag === 2) {
    //   model = (
    //     <div>
    //       <p className="input-form-label address-label">
    //         {" "}
    //         <FormattedMessage
    //           id="LbotherBankDetailsYouWanttoadd"
    //           defaultMessage="Would you like to add another bank details too?"
    //         />{" "}
    //       </p>
    //       <div
    //         className="form-btn form-control margin-right-20"
    //         onClick={this.SetFlag.bind(this, 1, false)}
    //       >
    //         <FormattedMessage id="Btyes" defaultMessage="Yes" />
    //       </div>
    //       <div
    //         className="form-btn form-control"
    //         onClick={this.SetFlag.bind(this, 3, false)}
    //       >
    //         <FormattedMessage id="Btno" defaultMessage="No" />
    //       </div>
    //     </div>
    //   );
    // }

    if (flag == 3) {
      console.log("flag: ", flag);

      model = (
        <div className="profile-data-view-page">
          {this.state.allBankingDetails.length > 0 ? (
            <div className="width100">
              <div>
                {this.state.allBankingDetails.map((data) => {
                  console.log("data: ", data);

                  return (
                    <div>
                      {/* <div className="emp-add-head">
                      <FormattedMessage id="LbBanking" defaultMessage="Banking" /></div> */}
                      <div className="padding-bottom-20 position-rel">
                      <span
                              className=""
                              style={{
                                // marginTop: 16,
                                fontSize: "12px",
                                padding: "2px 16px",
                                borderRadius: 20,
                                border:"solid 1px #008985",
                                background:"#dcf2f1",
                                color:"#008985",
                                height: 16,
                                display:"block",
                                width:160,
                                fontFamily: '"Muli", sans-serif !important'
                              }}
                            >
                            {/* <img className="list-item-icon" src={payrollglyph} />   */}
                            💵 Salary Deposit Bank A/c
                            </span>
                        {data.isdefault == false ? (
                          <div className="inlineClass" style={{marginTop: -35}}>
                            <p className="address-data">
                            
                            <br />
                              {data.bankname}
                              <br />
                              {data.accountnumber} 
                              <br />
                              {data.ifsccode}{" "}
                              <br />
                            </p>
                          </div>
                        ) : (
                         
                            
                          <div className="inlineClass" style={{marginTop: -35}}>
                            <p className="address-data">
                            
                            
                            <br />
                              {data.bankname}
                              <br />
                              {data.accountnumber} 
                              <br />
                              {data.ifsccode}{" "}
                              <br />
                            </p>
                          </div>
                        )}
                        <If condition={!hideButton}>
                          <div>
                            <svg
                              className={"address-edit cursour-pointer"}
                              onClick={this.GetPerticularBankingDetails.bind(
                                this,
                                3,
                                data,
                              )}
                              width="24"
                              // style={{ marginRight: 40 }}
                              height="24"
                              viewBox="0 0 24 24"
                            >
                              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                            </svg>
                            {/* <svg
                              className={"address-edit cursour-pointer"}
                              onClick={() => this.Deleteconfirmation(data)}
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z" />
                              <path fill="none" d="M0 0h24v24H0V0z" />
                            </svg> */}
                          </div>
                        </If>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div>No Record Found</div>
          )}

          {/* {!hideButton && (
            <div
              className={"add-more-button"}
              onClick={this.SetFlag.bind(this, 1, false)}
            >
              <Button variant="contained" color="primary" className="no-shadow">
                Add More
              </Button>
            </div>
          )} */}
        </div>
      );
    }

    return (
      <div>
        <Grid container spacing={2} style={{display : (flag == 0 && this.props.ismandate == true)? "none": ""}} >
          <Grid item xs={12} md={12} sm={12} >

          <Paper className="padding20" style={{ height: ((flag == 3)? 116 : 150), position: "relative"}} >
          <div className="position-rel" >{model}</div>
              <Drawer
                anchor="right"
                open={openDrawer}
                onClose={() => this.toggleDrawer(false)}
                classes={{
                  paper: classNames(classes.drawerPaper),
                }}
              >
                {openDrawer && (
                  <EmpBankingFormDrawer
                  SetFlag={this.SetFlag.bind(this)}
                  data={this.state.BankingDetails}
                  {...this.props}
                  toggleDrawer={this.toggleDrawer} 
                />
                )}
              </Drawer>
          </Paper>
          </Grid>
          {/* <Grid item xs={12} md={4} sm={12} >
          <Paper className="padding20" style={{ height: 150, position: "relative" }}>
              <div className="position-rel">
               <div style={{fontWeight: "bold", fontSize:17, marginTop:10}}>A Pro Salary account for a pro" </div>
               <div></div>
               <div style={{marginTop:20}}>Get On-Demand Salary, Free Health Cover,
                    Rewards on every spend, & much more!</div>
              </div>
          </Paper>
          </Grid> */}
          {/* <Grid item xs={12} md={6} sm={12}>
            <Paper className="padding20" style={{ height: 94 }}>
              <div className="position-rel">
                <div className="emp-subheading-icon" />
                <div className="emp-subheading nomargin">
                  <FormattedMessage id="LbTeam" defaultMessage="Team" />
                </div>
              </div>
              {this.state.EmpList.length > 0 ? (
                <div className="padding-top-10">
                  <div className="avtar-thumb-wrapper">
                    {this.state.EmpList.map((emp) => (
                      <div
                        className={
                          this.getCount(this.state.teamfullcount) > 0
                            ? "avtar-thumb-blur"
                            : "avtar-thumb"
                        }
                        key="key"
                      >
                        {this.state.colleagueid ? (
                          <Link to={`./${emp.employeeid}`} target="_blank">
                            <Tooltip
                              title={emp.employeename}
                              placement="bottom"
                            >
                              <div
                                className="avatar-wrapper"
                                onClick={this.SetColleagueInfo.bind(this, emp)}
                              >
                                {emp.imagepath == null ? (
                                  <img
                                    src={defaultEmp}
                                    height="50"
                                    className="team-avatar"
                                  />
                                ) : (
                                  <img
                                    src={getFormattedImageLink(emp.imagepath)}
                                    height="50"
                                    className="team-avatar"
                                  />
                                )}
                              </div>
                            </Tooltip>
                          </Link>
                        ) : (
                          <Tooltip title={emp.employeename} placement="bottom">
                            <Link
                              to={`./profile/${emp.employeeid}`}
                              target="_blank"
                            >
                              <div
                                className="avatar-wrapper"
                                onClick={this.SetColleagueInfo.bind(this, emp)}
                              >
                                {emp.imagepath == null ? (
                                  <img
                                    src={defaultEmp}
                                    height="50"
                                    className="team-avatar"
                                  />
                                ) : (
                                  <img
                                    src={getFormattedImageLink(emp.imagepath)}
                                    height="50"
                                    className="team-avatar"
                                  />
                                )}
                              </div>
                            </Link>
                          </Tooltip>
                        )}
                      </div>
                    ))}
                  </div>
                  {this.getCount(this.state.teamfullcount) > 0 ? (
                    <span
                      // className={classNames("teamdrawer")}
                      className={classNames("managercount", "cursour-pointer")}
                      onClick={this.HelperSliderFlag.bind(
                        this,
                        true,
                        "Profileteam",
                      )}
                    >
                      <span>
                        <div className="total-count">
                          +{this.getCount(this.state.teamfullcount)}
                        </div>
                      </span>
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <div style={{ paddingTop: 26 }}>
                  <span className="t-14">😎 You are a one person team</span>
                </div>
              )}
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} sm={12}>
            <Paper
              className="padding20"
              style={{
                height: 94,
              }}
            >
              <div className="position-rel">
                <div className="emp-subheading-icon" />
                <div className="emp-subheading nomargin">
                  <FormattedMessage
                    id="LbDepartment"
                    defaultMessage="Department"
                  />
                </div>
              </div>
              {this.state.DepList.length > 0 ? (
                <div className="padding-top-10">
                  <div className="avtar-thumb-wrapper">
                    {this.state.DepList.map((emp) => (
                      <div
                        className={
                          this.getCount(this.state.fullcount) > 0
                            ? "avtar-thumb-blur"
                            : "avtar-thumb"
                        }
                        key="key"
                      >
                        {this.state.colleagueid ? (
                          <Link to={`./${emp.employeeid}`} target="_blank">
                            <Tooltip
                              title={emp.employeename}
                              placement="bottom"
                            >
                              <div
                                className="avatar-wrapper"
                                onClick={this.SetColleagueInfo.bind(this, emp)}
                              >
                                {emp.imagepath == null ? (
                                  <img
                                    src={defaultEmp}
                                    height="50"
                                    className="team-avatar"
                                  />
                                ) : (
                                  <img
                                    src={getFormattedImageLink(emp.imagepath)}
                                    height="50"
                                    className="team-avatar"
                                  />
                                )}
                              </div>
                            </Tooltip>
                          </Link>
                        ) : (
                          <Tooltip title={emp.employeename} placement="bottom">
                            <Link
                              to={`./profile/${emp.employeeid}`}
                              target="_blank"
                            >
                              <div
                                className="avatar-wrapper"
                                onClick={this.SetColleagueInfo.bind(this, emp)}
                              >
                                {emp.imagepath == null ? (
                                  <img
                                    src={defaultEmp}
                                    height="50"
                                    className="team-avatar"
                                  />
                                ) : (
                                  <img
                                    src={getFormattedImageLink(emp.imagepath)}
                                    height="50"
                                    className="team-avatar"
                                  />
                                )}
                              </div>
                            </Link>
                          </Tooltip>
                        )}
                      </div>
                    ))}
                  </div>
                  {this.getCount(this.state.fullcount) > 0 ? (
                    <span
                      // className={classNames("teamdrawer drawer1")}
                      className={classNames("managercount", "cursour-pointer")}
                      onClick={this.HelperSliderFlag.bind(
                        this,
                        true,
                        "Profileteam",
                      )}
                    >
                      <span>
                        <div className="total-count">
                          +{this.getCount(this.state.fullcount)}
                        </div>
                      </span>
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <div style={{ paddingTop: 26 }}>
                  <span className="t-14">
                    💁‍♂️ You run the department single-handedly
                  </span>
                </div>
              )}
            </Paper>
          </Grid> */}
          {/* <Grid item xs={12} md={4} sm={12}>
            <Paper className="padding20" style={{ height: 94 }}>
              <div className="position-rel">
                <div className="emp-subheading-icon"></div>
                <div className="emp-subheading nomargin">
                  <FormattedMessage id="LbManager" defaultMessage="Manager" />
                </div>
              </div>
              {this.state.ManagerList.length > 0 ? (
                <div className="padding-top-10">
                  <div className="avtar-thumb-wrapper">
                    {this.state.ManagerList.map((mgr) => (
                      <div
                        className={
                          this.getCountManager(this.state.managerfullcount) > 0
                            ? "avtar-thumb-blur"
                            : "avtar-thumb"
                        }
                        key="key"
                      >
                        {this.state.colleagueid ? (
                          <Link to={`./${mgr.employeeid}`} target="_blank">
                            <Tooltip
                              key="key"
                              title={mgr.employeename}
                              placement="bottom"
                            >
                              <div className="avatar-wrapper">
                                {mgr.imagepath == null ? (
                                  <img
                                    src={defaultEmp}
                                    height="50"
                                    className="team-avatar"
                                  />
                                ) : (
                                  <img
                                    src={getFormattedImageLink(mgr.imagepath)}
                                    height="50"
                                    className="team-avatar"
                                  />
                                )}
                              </div>
                            </Tooltip>
                          </Link>
                        ) : (
                          <Tooltip
                            key="key"
                            title={mgr.employeename}
                            placement="bottom"
                          >
                            <Link
                              to={`./profile/${mgr.employeeid}`}
                              target="_blank"
                            >
                              <div className="avatar-wrapper">
                                {mgr.imagepath == null ? (
                                  <img
                                    src={defaultEmp}
                                    height="50"
                                    className="team-avatar"
                                  />
                                ) : (
                                  <img
                                    src={getFormattedImageLink(mgr.imagepath)}
                                    height="50"
                                    className="team-avatar"
                                  />
                                )}
                              </div>
                            </Link>
                          </Tooltip>
                        )}
                      </div>
                    ))}
                  </div>
                  {this.getCountManager(this.state.managerfullcount) > 0 ? (
                    <span
                      className={classNames("managercount", "cursour-pointer")}
                      onClick={this.HelperSliderFlag.bind(
                        this,
                        true,
                        "Profilemanager",
                      )}
                    >
                      <span>
                        <div className="total-count">
                          +{this.getCountManager(this.state.managerfullcount)}
                        </div>
                      </span>
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <div style={{ paddingTop: 26 }}>
                  <span className="t-14">💃 Yay! you are your own boss</span>
                </div>
              )}
            </Paper>
          </Grid> */}
        </Grid>
      </div>
    );
  }
}

EmpTeam.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateSubscriptionInfo: (type, payload) =>
        updateSubscriptionInfo(type, payload),
      RightDrawer: (data) => RightDrawer(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(EmpTeam)));
